module.exports = {
  title: `hyesungoh`,
  description: `Learning every moment`,
  author: `hyesungoh`,
  introduction: `Learning every moment`,
  siteUrl: `https://www.hyesungoh.xyz/`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `hyesungoh`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: `hyesungoh414`, // Your LinkedIn account
    instagram: `hyes5_`,
  },
  icon: `content/assets/felog.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: 'hyesungoh/blog', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    // 나중에 여권이나 면허증 나오면 추가하자
    buyMeACoffeeId: '',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'UA-206369437-1', // Add your google analytics tranking ID
};
